#import "../../../common/graphql/NotesEntityFields.graphql"

query NotesUserApproval($id: UUID!) {
  userApproval(id: $id) {
    id
    notesByEntityId(orderBy: _CREATED_DATE_DESC)  {
      nodes {
        ...NotesEntityFields
      }
    }
  }
}
